import React, {useEffect, useState} from 'react';
import { findManyProducts, getOrder, getProduct, getUserInfo } from '../apiUser';
import { isAuthenticated } from '../../auth';
import { useParams } from 'react-router-dom';
import Layout from '../../core/Layout';
import OrderDenied from './OrderDenied';
import { paymentStatus } from './apiOrders';
import { API } from '../../config';
import { CheckCircleIcon, ChevronRightIcon, MailIcon, RefreshIcon, ChatIcon } from '@heroicons/react/solid'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

/* PRocessing steps
 *  0. Trade accepted /order placed
 *  1. {other user} paid
 *  2. {other user} shipped
 *  3. Arrived at Lootswap verification
 *  4. Shipping to you
 *  5. Arrived to you
*/

const Order = () => {
    const { orderId } = useParams();
    const [order, setOrder] = useState({});

    const [formatDate, setFormatDate] = useState('');

    const [recieverProduct, setRecieverProduct] = useState({});
    const [senderProducts, setSenderProducts] = useState([]);

    const [recieverInfo, setRecieverInfo] = useState({});
    const [senderInfo, setSenderInfo] = useState({});

    const { user: {_id}, token } = isAuthenticated();
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    const [canceled, setCanceled] = useState(false);

    const ShowError = () => 
        error && (
            <>
                There was a problem processing your order click here to try again
            </>
        );

    useEffect(() => {
        paymentStatus(_id, orderId, token).then(orderData => {
            if (orderData.error) {
                setError(true);

            }
            else {
                console.log(orderData);
                setOrder(orderData);
            }

            var date = new Date(orderData.createdAt);
            var dateString = (date.getMonth()+1) + '-' + date.getDate() + '-' + date.getFullYear();
            
            setFormatDate(dateString);

            getProduct(orderData.recieverItemId).then(recieverData => setRecieverProduct(recieverData));
            findManyProducts(orderData.senderItemIds).then(senderData => setSenderProducts(senderData));

            getUserInfo(orderData.reciever).then(recieverData => setRecieverInfo(recieverData));
            getUserInfo(orderData.sender).then(senderData => setSenderInfo(senderData));


            setLoading(false);
        });


    },[]);

    const ShowLoading = () => (
        <> Loading ... </>
    );

    const OrderInfo = () => (
        <div className="bg-gray-50">
            <div className="max-w-2xl mx-auto pt-16 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
                <div className="px-4 space-y-2 sm:px-0 sm:flex sm:items-baseline sm:justify-between sm:space-y-0">
                    <div className="flex sm:items-baseline sm:space-x-4">
                        {order.reciever === _id ?
                        <h1 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">Order with {senderInfo.name}</h1>
                        :
                        <h1 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">Order with {recieverInfo.name}</h1>
                        }
                        <a href={`/trade/${order.tradeId}`} className="hidden text-sm font-medium text-indigo-600 hover:text-indigo-500 sm:block">
                            Go to trade<span aria-hidden="true"> &rarr;</span>
                        </a>
                    </div>
                    <p className="text-sm text-gray-600">
                        Order placed{' '}
                        <time dateTime="2021-03-22" className="font-medium text-gray-900">
                            {formatDate}
                        </time>
                    </p>
                    <a href={`/trade/${order.tradeId}`} className="text-sm font-medium text-indigo-600 hover:text-indigo-500 sm:hidden">
                        Go to trade <span aria-hidden="true"> &rarr;</span>
                    </a>
                </div>

                {/* Products */}
                <div className="mt-6">
                    <h2 className="sr-only">Products purchased</h2>

                    <div className="space-y-8">
                        <div
                            className="bg-white border-t border-b border-gray-200 shadow-sm sm:border sm:rounded-lg"
                        >
                            <div className="py-6 px-4 sm:px-6 lg:grid lg:grid-cols-12 lg:gap-x-8 lg:p-8">
                                <div className="sm:flex lg:col-span-7">
                                    {/*
                                    <div className="flex-shrink-0 w-full aspect-w-1 aspect-h-1 rounded-lg overflow sm:aspect-none sm:w-40 sm:h-40">

                                        {order.reciever === _id ?
                                            <>
                                                {senderProducts.map(product => (
                                                    <img 
                                                        src={`${API}/static/product_photos/${product.primary_photo}`} 
                                                        alt={product.name} 
                                                        className=" object-center object-cover" 
                                                    />
                                                ))}
                                            </>
                                            :
                                            <img 
                                                src={`${API}/static/product_photos/${recieverProduct.primary_photo}`} 
                                                alt={recieverProduct.name} 
                                                className="w-full h-full object-center object-cover sm:w-full sm:h-full" 
                                            />
                                        }

                                    </div>
                                    */}

                                    <div className="mt-6 sm:mt-0 sm:ml-6">
                                        <h3 className="text-base font-medium text-gray-900">
                                            {order.reciever === _id ?

                                                <p>
                                                    <span className='flex'>
                                                        {senderProducts.map((senderItem,i) => (
                                                            <>
                                                                {senderItem.name}{i !== senderProducts.length-1 ? ', ' : ''} 
                                                            </>
                                                        ))}
                                                    </span>

                                                </p>
                                                :

                                                <p>{recieverProduct.name}</p>
                                            }
                                        </h3>
                                        <p className="mt-2 text-sm font-medium text-gray-600">Tracking number</p>
                                        { order.reciever === _id ?
                                            <a 
                                                href={`${order.recieverShippoData.toWarehouse.tracking_url_provider}`}
                                                className='text-blue-500'
                                            >
                                                {order.recieverShippoData.toWarehouse.tracking_number}
                                            </a>
                                            :
                                            <a 
                                                href={`${order.senderShippoData.toWarehouse.tracking_url_provider}`}
                                                className='text-blue-500'
                                            >
                                                {order.senderShippoData.toWarehouse.tracking_number}
                                            </a>
                                        }
                                    </div>
                                </div>

                                <div className="mt-6 lg:mt-0 lg:col-span-5">
                                    <dl className="grid grid-cols-2 gap-x-6 text-sm">
                                        <div>
                                            <dt className="font-medium text-gray-900">Delivering To</dt>
                                            <dd className="mt-3 text-gray-500">

                                                    {_id === order.reciever ?
                                    <>
                                        <span className="block">{order.recieverShipping.name}</span>
                                        <span className="block">{order.recieverShipping.street1}</span>
                                        <span className="block">{order.recieverShipping.city}  {order.recieverShipping.state} {}</span>
                                    </>
                                    :
                                    <>
                                        <span className="block">{order.senderShipping.name}</span>
                                        <span className="block">{order.senderShipping.street1}</span>
                                        <span className="block">{order.senderShipping.city}  {order.senderShipping.state} {}</span>
                                        <div className='mt-4'>
                                        </div>
                                    </>
                                }


                                            </dd>
                                        </div>
                                        <div>
                                            <a target='_blank' href={
                                                order.reciever === _id ?
                                                    order.recieverShippoData.toWarehouse.label_url :
                                                    order.senderShippoData.toWarehouse.label_url
                                                
                                            }>
      <button
        type="button"
        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-orange-600 "

      >
          Print Shipping Label
      </button>
                                            </a>

                                        </div>
                                    </dl>
                                </div>
                            </div>

                            <div className="border-t border-gray-200 py-6 px-4 sm:px-6 lg:p-8">
                                <h4 className="sr-only">Status</h4>
                                <p className="text-sm font-medium text-gray-900">
                                    Status
                                </p>
                                <div className="mt-6" aria-hidden="true">
                                    <div className="bg-gray-200 rounded-full overflow-hidden">
                                        <div
                                            className="h-2 bg-indigo-600 rounded-full"
                                            style={{ width: `calc((${order.reciever === _id ? order.senderStep : order.recieverStep} * 2 + 1) / 12 * 100%)` }}
                                        />
                                    </div>

                                    <div className="hidden sm:grid grid-cols-6 text-sm font-medium text-gray-600 mt-6">
                                        <div className="text-indigo-600">Trade Accepted</div>
                                        <div className={classNames(order.step > 0 ? 'text-indigo-600' : '', 'text-center')}>
                                            Other user paid
                                        </div>
                                        <div className={classNames(order.step > 1 ? 'text-indigo-600' : '', 'text-center')}>
                                            Other user shipped
                                        </div>

                                        <div className={classNames(order.step > 2 ? 'text-indigo-600' : '', 'text-center')}>
                                            Lootswawp verification
                                        </div>

                                        <div className={classNames(order.step > 3 ? 'text-indigo-600' : '', 'text-center')}>
                                            Shipping to you
                                        </div>
                                        <div className={classNames(order.step > 4 ? 'text-indigo-600' : '', 'text-center')}>
                                            Arrived to you
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );

    const RenderOptions = () => {
        if (error) { return(<ShowError/>) }

        if (order.recieverStep === -1 || order.senderStep === -1) {
            return (<OrderDenied order={order} _id={_id}/>);
        }

        if (order && order.reciever === _id) {


            if (order.recieverPaymentStatus === 'succeeded') {
                return (
                    <>
                        <OrderInfo/> 
                    </>
                );
            }

        }
        else { //sender


            console.log('sender');
            if (order.senderPaymentStatus === 'succeeded') {
                return (
                    <>
                        <OrderInfo/> 
                    </>
                );
            }
            else if (order.senderPaymentStatus === 'pending') {
                return (
                    <> pending </>
                );
            }
            else {
                return (
                <> there was an error processing your order, click here to try again </>
                );
            }

        }
    };

    return (
        <Layout>
            {loading ?
                <ShowLoading/>
                :
                <RenderOptions/>
            }
        </Layout>
    );


};

export default Order;
